import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalWrapperService, NotesLogService } from 'src/app/services';
import { appState } from 'src/app/store/appstate';

@Component({
  selector: 'app-common-notes-log',
  templateUrl: './common-notes-log.component.html',
  styleUrls: ['./common-notes-log.component.scss'],
  standalone: false
})
export class CommonNotesLogComponent implements OnInit {
  @ViewChild("RxNotesLogListPopUp", { static : true })
  RxNotesLogListPopUp : any;
  modelRefRph : any;
  notesList: any;
  IsNotesLogPopupClosedCalled: any;

  @Input()
    set NotesListFrmPage(list: any) {
      console.log(list , "listlist")
        this.notesList = list;
    }


  @Input() IsFromeRx: boolean;
  @Input() HeaderText: boolean;
  @Input() IsFromPage: string;
  @Input() RxType: any;
  
  
  
  @Output() IsNotesLogPopupClosed = new EventEmitter<any>();

  constructor(private _modalService: ModalWrapperService, private _notesLog :NotesLogService) { 
  }

  ngOnInit(): void {
    this.modelRefRph = this._modalService.open(this.RxNotesLogListPopUp, {keyboard : false, backdrop : false, centered : true , windowClass: "max-modal-1070"  });
    appState.popupOpendList = appState.popupOpendList ? [...appState.popupOpendList, {name: 'CommonNotesLog', onClosePopup: ()=> new Promise((resolve) => { this.IsNotesLogPopupClosed.subscribe(() => resolve(true)); })}] : [{name: 'CommonNotesLog', onClosePopup: ()=> new Promise((resolve) => { this.IsNotesLogPopupClosed.subscribe(() => resolve(true)); })}];
    if((this.modelRefRph as any)?.onClose) {
      (this.modelRefRph as any)?.onClose.then((res)=>{
        if(res === 'esc' && !this.IsNotesLogPopupClosedCalled){
          this.IsNotesLogPopupClosed.emit();
          appState.popupOpendList = appState.popupOpendList.filter((x: any) => x.name !== "CommonNotesLog");
        }
      });
    }
  }
  closeModal(type?){
    if(this.modelRefRph){
      this.IsNotesLogPopupClosedCalled = true;
      this.modelRefRph.close();
      this.IsNotesLogPopupClosed.emit(type ? type : true);
      setTimeout(() => {
        appState.popupOpendList = appState.popupOpendList.filter((x: any) => x.name !== "CommonNotesLog");
        this.IsNotesLogPopupClosedCalled = false;
      }, 200);
    }
  }
async changeStatus(notesItem, isChecked, noteType) {
    await this._notesLog.updateNotesStatus(notesItem.Id, isChecked, noteType, this.RxType).toPromise();
}
ngOnChanges(changes?: any): void {
}
ngAfterViewInit(): void {
}
}
